import Vue from 'vue';
import Vuetify from 'vuetify/lib';
import cs from 'vuetify/src/locale/cs';

Vue.use(Vuetify);

export default new Vuetify({
  theme: {
    options: {
      customProperties: true,
    },
    themes: {
      light: {
        primary: '#F24F00',
        secondary: '#424242',
        accent: '#82B1FF',
        error: '#FF5252',
        info: '#2196F3',
        success: '#4CAF50',
        warning: '#FFC107',
        colorHeadlineStandard: '#FFAB91',
        colorHeadlineWarning: '#FF7150',
        colorHeadlineDelete: '#FF8787',
        colorRowSelected: '#FFC8AD',
        colorSearchSettings: '#F8F8F8', // Hladanie v nastaveniach
        colorOK: '#4CD152',
        colorERR: '#F24F00',
        colorNew: '#FFECBE',
        colorSave: '#8DF2AF',
        colorAdd: '#FFECBE',
        colorEdit: '#FFE5B1',
        colorDelete: '#FF8787',
        colorClose: '#E0E0E0',
        colorArrows: '#FF6C25',
        colorActiveTab: '#FFF2EC',
      },
    },
  },
  lang: {
    locales: { cs },
    current: 'cs',
  },
});
